import { Product } from '../../interfaces/Product/Product';
import { BreadcrumbElement } from '../../interfaces/Breadcrumb/BreadcrumbElement';
import { GenericBreadcrumbs } from './GenericBreadcrumbs';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type ProductBreadcrumbsProps = {
  product: Product;
};

export const ProductBreadcrumbs = ({ product }: ProductBreadcrumbsProps) => {
  const t = useLocalizedText();

  const breadcrumbElements: BreadcrumbElement[] = [
    ...(product.brand.name
      ? [
          {
            name: t('brand.brands'),
            url: 'markalar',
          },
          {
            name: product.brand.name,
            url: `marka/${product.brand.slug}`,
          },
        ]
      : []),
    {
      name: product.name,
      url: `urun/${product.slug}`,
    },
  ];

  return (
    <GenericBreadcrumbs
      breadcrumbElements={breadcrumbElements}
      sx={{ mb: -1.5 }}
    />
  );
};
